import { render, staticRenderFns } from "./curriculum_photo_bannerimage.vue?vue&type=template&id=d5cfd35c&"
import script from "./curriculum_photo_bannerimage.vue?vue&type=script&lang=js&"
export * from "./curriculum_photo_bannerimage.vue?vue&type=script&lang=js&"
import style0 from "./curriculum_photo_bannerimage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports